import { t } from "i18next";

export const confirmationAlert = () => {
  return window.confirm(t("common.lost_data"));
};
